import {Icon, Modal} from '@/components/atoms';
import {useState} from 'react';
import {useIntl} from 'react-intl';

export const HeaderExtraItems = () => {
  return <UserGuide />;
};

const UserGuide = () => {
  const {formatMessage} = useIntl();

  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <button
        className='flex w-full gap-2 rounded-lg px-4 py-2 outline-none hover:bg-button-icon-hover/5'
        title={formatMessage({id: 'HEADER.USER_GUIDE_LINK'})}
        data-testid='user-guide-button'
        data-cy='user-guide-button'
        onClick={() => setIsOpen(true)}>
        <Icon
          icon='info'
          size='medium'
          className='text-white'
          data-testid='information-icon'
        />
      </button>

      <Modal
        showModal={isOpen}
        title={formatMessage({id: 'HEADER.USER_GUIDE_LINK'})}
        content={<></>}
        secondaryButtonText={formatMessage({id: 'GENERAL.CLOSE'})}
        onClickSecondaryButton={() => setIsOpen(false)}
        onCloseModal={() => setIsOpen(false)}
        classNameWrapper='h-[calc(100vh-18rem)] w-[calc(100vw-10rem)] max-w-[50rem] mb-4'
      />
    </>
  );
};
